export interface IUser {
  userID: number;
  firstName: string;
  lastName: string;
  userRole: UserRole;
  branchTypeID: number;
  rmbId: number;
  email: string;
  password: string;
  isDeleted: boolean;
  createdDate: string;
  modifiedDate: string;
}

export const defaultValue: Readonly<IUser> = {
  userID: null,
  firstName: "",
  lastName: "",
  userRole: null,
  branchTypeID: null,
  rmbId: null,
  email: "",
  password: "",
  isDeleted: null,
  createdDate: "",
  modifiedDate: "",
};

// Warning: use production IDs here
export enum UserRole {
  Admin = 1,
  ProposalSpecialist = 2,
  RegionalBranchManager = 3,
  BranchManager = 4,
  UnderwritingAssociate = 5,
  Marketer = 7,
  IOSpecialist = 8,
}

export const UserRoleOptions = [
  { value: UserRole.Admin, key: "Admin" },
  { value: UserRole.ProposalSpecialist, key: "Proposal Specialist" },
  { value: UserRole.RegionalBranchManager, key: "Regional Branch Manager" },
  { value: UserRole.BranchManager, key: "Branch Manager" },
  { value: UserRole.UnderwritingAssociate, key: "Underwriting Associate" },
  { value: UserRole.Marketer, key: "Marketer" },
  { value: UserRole.IOSpecialist, key: "IO Specialist" },
];
